import React from "react";
import PropTypes from "prop-types";

import DialogTitle from "ui/DialogTitle";

import { Dialog } from "@mui/material";

import Content from "./Content";
import DialogActions from "components/DialogActions";

const ColorPickerDialog = ({ open, onClose, onChange, highlightColor }) => {

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle title="Choose a Highlight Color" onClose={onClose} />

      <Content
        highlightColor={highlightColor}
        onChange={onChange}
      />

      <DialogActions 
        onCancel={onClose} 
        onClose={onClose} 
        disabled={!highlightColor?.trim()}
      />

    </Dialog>
  );
};

ColorPickerDialog.propTypes = {
  open: PropTypes.bool,
  highlightColor: PropTypes.string,
  onClose: PropTypes.func,
  onChange: PropTypes.func,
};

export default ColorPickerDialog;
